import type { ReactNode } from "react";
import { Icon, type IconName } from "./icons.js";

interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

/** Consistent empty / no-data state. */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state__icon"><Icon name={icon} size={34} strokeWidth={1.5} /></div>}
      <div className="empty-state__title">{title}</div>
      {description && <div className="empty-state__desc">{description}</div>}
      {action}
    </div>
  );
}
